import type { IDocumentService }        from './IDocumentService';
import type { WarehouseDocument }       from '../dto/Document.dto';
import { ListParams }                   from '../http/ListParams';
import { QueryBuilder }                 from '../http/QueryBuilder';
import { JsonRequestBody }              from '../http/JsonRequestBody';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { fetchWithAuth }                from '../../../utils/fetch/FetchWithAuth';
import { PagedResponse } from '../dto/PagedResponse';
import { WarehouseDocumentDetail } from '../dto/WarehouseDocumentDetail';
import { CreateDocumentRequest } from '../dto/CreateDocumentRequest';
import { UpdateDocumentRequest } from '../dto/UpdateDocumentRequest';
import { CreateLineItemRequest } from '../dto/CreateLineItemRequest';
import type { DocumentLineItem } from '../dto/DocumentLineItem';
import { UpdateLineItemRequest } from '../dto/UpdateLineItemRequest';

const BASE = '/api/warehouse/document';

export class DocumentService implements IDocumentService {
    async list(params?: ListParams): Promise<PagedResponse<WarehouseDocument>> {
        return fetchWithAuth(
            `${BASE}${QueryBuilder.from(params).build()}`,
            { method: 'GET' }
        );
    }

    async get(externalId: string): Promise<WarehouseDocumentDetail> {
        return fetchWithAuth(`${BASE}/${externalId}`, { method: 'GET' });
    }

    async create(payload: CreateDocumentRequest): Promise<WarehouseDocument> {
        return fetchWithAuth(BASE, { method: 'POST', ...JsonRequestBody.from(payload) });
    }

    async update(externalId: string, payload: UpdateDocumentRequest): Promise<WarehouseDocument> {
        return fetchWithAuth(`${BASE}/${externalId}`, { method: 'PATCH', ...JsonRequestBody.from(payload) });
    }

    async delete(externalId: string): Promise<void> {
        return fetchWithAuth(`${BASE}/${externalId}`, { method: 'DELETE' });
    }

    async close(externalId: string): Promise<WarehouseDocumentDetail> {
        return fetchWithAuth(`${BASE}/${externalId}/close`, { method: 'POST' });
    }

    async addLineItem(externalId: string, payload: CreateLineItemRequest): Promise<DocumentLineItem> {
        return fetchWithAuth(`${BASE}/${externalId}/item`, { method: 'POST', ...JsonRequestBody.from(payload) });
    }

    async updateLineItem(externalId: string, itemId: string, payload: UpdateLineItemRequest): Promise<DocumentLineItem> {
        return fetchWithAuth(`${BASE}/${externalId}/item/${itemId}`, { method: 'PATCH', ...JsonRequestBody.from(payload) });
    }

    async deleteLineItem(externalId: string, itemId: string): Promise<void> {
        return fetchWithAuth(`${BASE}/${externalId}/item/${itemId}`, { method: 'DELETE' });
    }
}